module.exports = __webpack_public_path__ + "img/3.339d1e94.jpg";